import React from 'react';
export const ChatMessage = ({
  type,
  content
}) => {
  return <div className="flex items-start gap-3 mb-4" data-id="element-24">
      {type === 'user' ? <div className="flex items-center justify-center w-8 h-8 rounded-full bg-gray-100" data-id="element-25">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-gray-600" data-id="element-26">
            <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" data-id="element-27" />
            <circle cx="12" cy="7" r="4" data-id="element-28" />
          </svg>
        </div> : <div className="flex items-center justify-center w-8 h-8 rounded-full bg-purple-100" data-id="element-29">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-[#6A36FC]" data-id="element-30">
            <path d="M2.97 12.92A2 2 0 0 0 2 14.63v3.24a2 2 0 0 0 .97 1.71l3 1.8a2 2 0 0 0 2.06 0L12 19v-5.5l-5-3-4.03 2.42Z" data-id="element-31" />
            <path d="m7 16.5-4.74-2.85" data-id="element-32" />
            <path d="m7 16.5 5-3" data-id="element-33" />
            <path d="M7 16.5v5.17" data-id="element-34" />
            <path d="M12 13.5V19l3.97 2.38a2 2 0 0 0 2.06 0l3-1.8a2 2 0 0 0 .97-1.71v-3.24a2 2 0 0 0-.97-1.71L17 10.5l-5 3Z" data-id="element-35" />
            <path d="m17 16.5-5-3" data-id="element-36" />
            <path d="m17 16.5 4.74-2.85" data-id="element-37" />
            <path d="M17 16.5v5.17" data-id="element-38" />
            <path d="M7.97 4.42A2 2 0 0 0 7 6.13v4.37l5 3 5-3V6.13a2 2 0 0 0-.97-1.71l-3-1.8a2 2 0 0 0-2.06 0l-3 1.8Z" data-id="element-39" />
            <path d="M12 13.5V8" data-id="element-40" />
            <path d="m7 6.5 5 3 5-3" data-id="element-41" />
          </svg>
        </div>}
      <div className="max-w-[80%]" data-id="element-42">
        <p className="px-4 py-2 rounded-lg bg-white border shadow-sm" data-id="element-43">
          {content}
        </p>
      </div>
    </div>;
};